import type { TOC } from '@ember/component/template-only';
import t from 'ember-intl/helpers/t';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}
export default <template>
  <@form.NumberInput
    @propertyName='stoolsNumber'
    @labelName={{t 'mici-form.stoolsNumber.long' htmlSafe=true}}
    @min='0'
  />
</template> satisfies TOC<Signature>;
